const EVENT = 'allocation-overview-invalidated';
const CHANNEL = 'allocation-overview';
let channel;
function getChannel() {
  if (channel === undefined) {
    try { channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL) : null; }
    catch { channel = null; }
  }
  return channel;
}

// Pure classifier: only authoritative successful writes reach this function.
export function mutationScope(config = {}) {
  if (!['post', 'put', 'patch', 'delete'].includes((config.method || '').toLowerCase())) return undefined;
  let path;
  try { path = new URL(config.url || '', 'http://local').pathname.replace(/^\/api\//, '/'); }
  catch { return undefined; }
  // Preview POSTs can use the real mutation URL; Axios may already have serialized the body.
  let data = config.data;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch { data = null; }
  }
  if (data?.preview === true) return undefined;
  if (/\/(generate_invoice|set_request_receiver|[a-z-]+-preview|site_pdf|primary-contact\/[^/]+)\/?$/.test(path)) return undefined;
  const setup = path.match(/^\/allocation-setups\/(\d+)(?:\/|$)/);
  if (setup) {
    if (/\/(activate|reopen|lock|duplicate)\//.test(path)) return null;
    return setup[1];
  }
  // Writes that never change what the overview shows (previews, invoices, request routing, PDFs, contacts).
  if (/^\/(allocation-setups|sites|vehicles|plows|staff|double-down|clients|vehicle-subtypes|fleetio_connect|walkwayCrew|saltingRoute|bambooHR)(\/|$)/.test(path)) return null;
  return undefined;
}

export function notifyOverviewMutation(config) {
  const setupId = mutationScope(config);
  if (setupId === undefined || typeof window === 'undefined') return;
  const detail = { setupId };
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
  try { getChannel()?.postMessage(detail); } catch { /* Polling remains available. */ }
}

export function subscribeOverview(setupId, callback) {
  const receive = detail => {
    if (detail && (detail.setupId === null || String(detail.setupId) === String(setupId))) callback();
  };
  const local = e => receive(e.detail);
  const remote = e => receive(e.data);
  window.addEventListener(EVENT, local);
  const bus = getChannel();
  bus?.addEventListener('message', remote);
  return () => { window.removeEventListener(EVENT, local); bus?.removeEventListener('message', remote); };
}
